/**
 * InvisibleToggle — opt-in invisible mode in preferences (Phase C, AC-18.1).
 *
 * While invisible the server never emits the caller's presence to anyone; the
 * caller still receives others' presence. Gated by `social.dm_presence`.
 */

import { useState } from 'react';
import { usePresence } from '../../context/PresenceContext';
import { useFeatureFlag } from '../../hooks/useFeatureFlag';

export function InvisibleToggle() {
  const enabled = useFeatureFlag('social.dm_presence');
  const { invisible, setInvisible } = usePresence();
  const [busy, setBusy] = useState(false);

  if (!enabled) return null;

  const toggle = async () => {
    setBusy(true);
    try {
      await setInvisible(!invisible);
    } finally {
      setBusy(false);
    }
  };

  return (
    <label className="invisible-toggle">
      <input type="checkbox" checked={invisible} disabled={busy} onChange={toggle} />
      <span>Appear invisible to connections</span>
    </label>
  );
}

export default InvisibleToggle;
